import * as isomorphicLocalStorage from 'lib/storage/isomorphicLocalStorage'
import { DurationSeconds } from 'lib/datetime/durationInSeconds'

export const TIER_PROGRESS_SNACKBAR_STORAGE_PREFIX = 'loyalty-tier-progress-snackbar-'
const SEVENTY_TWO_HOURS_MS = DurationSeconds.THREE_DAYS * 1000 // 72 hours in milliseconds

function getStorageKey(memberId: string) {
  return `${TIER_PROGRESS_SNACKBAR_STORAGE_PREFIX}${memberId}`
}

export function isSnackbarShown(memberId: string): boolean {
  const shownAt: number | undefined = isomorphicLocalStorage.get(getStorageKey(memberId))
  if (!shownAt) return false

  // Check if 72 hours have passed
  if (Date.now() - shownAt > SEVENTY_TWO_HOURS_MS) {
    // Auto-cleanup expired entry
    isomorphicLocalStorage.remove(getStorageKey(memberId))
    return false
  }

  return true
}

export function markSnackbarAsShown(memberId: string): void {
  isomorphicLocalStorage.set(getStorageKey(memberId), Date.now())
}
